import { PropsWithChildren } from 'react';

import { ChannelsList } from '@/components/ChannelsList';
import { LayoutContainer } from '@/styled/common';

interface ChatLayoutProps {
  selectedChannelId?: string;
  isShowChannelList?: boolean;
}

export const ChatLayout = ({
  children,
  selectedChannelId,
  isShowChannelList = true
}: PropsWithChildren<ChatLayoutProps>) => {
  return (
    <LayoutContainer>
      {isShowChannelList && (
        <ChannelsList selectedChannelId={selectedChannelId} />
      )}
      {children}
    </LayoutContainer>
  );
};
